import {
  Component,
  inject,
  OnInit,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { AccordionComponent } from '@ppl/ui';
import {
  FormsModule,
  ReactiveFormsModule,
  FormGroup,
  FormBuilder,
} from '@angular/forms';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { AllowListAuthStore } from '../../../../shared/authorization/allow-list-auth.store';
import { AuthorizeDirective } from '../../../../shared/authorization/authorize.directive.';
import { ButtonComponent } from '@ppl/ui';
import { ListTableComponent } from '@ppl/ui';
import {
  MEMBER_VIEW_PAGE_IDS,
  TABS,
} from '../../../../shared/constants/page.constants';
import { STATIC_DATA } from '../../../../shared/constants/static-data.constants';
import { TableRowActions } from '../../../../shared/interfaces/actions';
import { TableRowActionsModel } from '../../../../shared/interfaces/list.interface';
import { NgZorroModule } from '../../../../shared/modules/ng-zorro/ng-zorro.module';
import {
  DialogService,
  DialogConfig,
} from '../../../../shared/services/dialog.service';
import { ErrorAlertService } from '../../../../shared/services/error-alert.service';
import { TimesheetViewComponent } from '../timesheet-view/timesheet-view.component';
import { TimesheetNewEntriesComponent } from '../timesheets-add-entries/timesheets-add-entries.component';
import { LookupService } from '../../../../services/lookup.service';
import { TimesheetService } from '../../../../services/timesheet.service';
import { DateTimeFormatterService } from '../../../../shared/utils/date-time-formatter.service';
import { ListService } from '../../../../shared/services/list.service';
import CommonUtil from '../../../../shared/authorization/common.util';
import { LookupValueItem } from '../../../../interfaces/lookup.interface';
import { UserService } from '../../../../services/user.service';
import { ProviderService } from '../../../../services/provider.service';

@Component({
  selector: 'ppl-timesheet-consumer-list',
  standalone: true,
  imports: [
    AccordionComponent,
    ListTableComponent,
    NgZorroModule,
    ButtonComponent,
    AuthorizeDirective,
    NzSelectModule,
    FormsModule,
    NzFormModule,
    ReactiveFormsModule,
    TimesheetViewComponent,
  ],
  templateUrl: './timesheet-consumer-list.component.html',
  styleUrl: './timesheet-consumer-list.component.css',
})
export class TimesheetConsumerListComponent implements OnInit {
  @ViewChild('inProcessTimesheetChildComponent') inProcessTimesheetChildComponent?: ListTableComponent;
  @ViewChild('completedTimesheetChildComponent') completedTimesheetChildComponent?: ListTableComponent;
  entry!: string;
  sharedDataKey: string = STATIC_DATA.SHARED_REFERRAL_DATA;
  pageId = '';
  columnsToBeHidden: string[] = [];
  actionsToBeHidden: string[] = [];
  isPageRestrictionLoaded = false;
  actionButtonsProcessed: TableRowActionsModel = new TableRowActions({
    view: true,
  });
  actionButtonsInProcess: TableRowActionsModel = new TableRowActions({
    view: true,
  });
  @ViewChild('timesheetViewDialog') timesheetViewDialog!: TemplateRef<any>;
  @ViewChild('denyDialog') denyDialog!: TemplateRef<any>;
  private dialogSvc = inject(DialogService);
  tabId: string = TABS.TIMESHEET;
  inProcessTimesheetSearchForm!: FormGroup;
  timesheetSearchForm!: FormGroup;
  programName!: string;
  timeEntry = '';
  isProcessed = false;
  listOfOption: any;
  selectedReason = '';
  consumerId: any;
  consumerLineData: any;
  providerPplId: any;
  rowData: any;
  providers: any[] = [];
  payPeriod: any[] = [];
  inProcessConsumerTimesheets: any[] = [];
  processedConsumerTimesheets: any[] = [];
  // Keep the applied search filters so paging past page 1 refetches the same
  // filtered result set instead of falling back to an unfiltered query.
  private inProcessSearchParams: any[] = [];
  private processedSearchParams: any[] = [];
  viewDialogId: any;
  businessStatusList: any;
  processingStatusList: any;
  reasonList: any;

  inProcessFilterStatus = [
    {
      lkpValueCode: 'AC',
      lkpValueName: 'Awaiting Approval',
    },
    {
      lkpValueCode: 'CD',
      lkpValueName: 'Participant Rejected',
    },
    {
      lkpValueCode: 'GP',
      lkpValueName: 'Good to pay',
    },
    {
      lkpValueCode: 'I',
      lkpValueName: 'In review',
    },
  ];

  status = [
    {
      lkpValueCode: 'D',
      lkpValueName: 'Denied',
    },
    {
      lkpValueCode: 'P',
      lkpValueName: 'Paid',
    },
  ];

  cols = [
    {
      field: 'providerName',
      header: 'Provider Name',
      jsonpath: 'providerName',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'providerPplId',
      header: 'Provider PPL ID',
      jsonpath: 'providerPplId',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'serviceDate',
      header: 'Service Date',
      jsonpath: 'serviceDate',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'timeIn',
      header: 'Time In',
      jsonpath: 'timeIn',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'timeOut',
      header: 'Time Out',
      jsonpath: 'timeOut',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    // {
    //   field: 'payrollStartDate',
    //   header: 'Payroll Start Date',
    //   jsonpath: 'payrollStartDate',
    //   isDisplayedAtHeader: 'y',
    //   isSearchable: 'n',
    // },
    // {
    //   field: 'payrollEndDate',
    //   header: 'Payroll End Date',
    //   jsonpath: 'payrollEndDate',
    //   isDisplayedAtHeader: 'y',
    //   isSearchable: 'n',
    // },
    {
      field: 'businessStatus',
      header: 'Status',
      jsonpath: 'businessStatus',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    }
  ];
  isReadOnly = false;
  canApproveReject = true;
  selectedInProcessRows: any[] = [];
  /** True when the pending deny dialog was opened from the bulk Reject button. */
  isBulkDeny = false;

  /** Only lines awaiting participant approval can be bulk approved/rejected. */
  inProcessSelectionDisabler = (row: any): boolean =>
    row?.business_status_lkp !== 'AC';

  get canBulkApproveReject(): boolean {
    return !this.isReadOnly && this.canApproveReject;
  }

  constructor(
    private fb: FormBuilder,
    private lookupService: LookupService,
    private timesheetService: TimesheetService,
    private dateTimeFormatterService: DateTimeFormatterService,
    private listService: ListService,
    private userService: UserService,
    private providerService: ProviderService,
    private allowListStore: AllowListAuthStore,
    private errorAlertService: ErrorAlertService
  ) { }

  ngOnInit(): void {
    this.entry = this.userService.getLeadEntry() ?? '';
    this.pageId = MEMBER_VIEW_PAGE_IDS[this.userService.getFirstSegment()!];
    const selectedProgram = this.userService.getSelectedProgram();
    this.programName = selectedProgram?.program_code ?? '';
    this.consumerId = this.userService.getSelectedLead()!;

    this.businessStatusList = this.lookupService.getLookupValue('Business Status');
    this.processingStatusList = this.lookupService.getLookupValue('TS_App_S');
    this.reasonList = this.lookupService.getLookupValue('Manual Entry reason');

    const denyReasons = this.lookupService.getLookupValue(
      'consumer_ts_denial'
    );
    this.listOfOption = denyReasons.map((item: any) => item.lkpValueName);
    const userDetails = this.userService.getUserDetails();
    const isInRole = selectedProgram?.roles.some((role: any) => role.role_name === 'PPL Staff Tier 1') && userDetails?.usertype_lkp === 'FMS';
    if (isInRole) {
      this.isReadOnly = true;
    }
    this.inProcessTimesheetSearchForm = this.fb.group({
      paPplId: [null],
      paName: [null],
      status: [null],
    });
    this.timesheetSearchForm = this.fb.group({
      payPeriod: [null],
      provider: [null],
      status: ['P'],
    });
    this.setPageAccess();
    this.getProviders();
    this.getPayPeriod();
    this.loadInitData();
  }

  loadInitData() {
    this.loadInProgressData();
    this.loadProcessedData();
  }

  onInProcessTimesheetPageLoad(event: any) {
    this.loadInProgressData(event.startingPageNumber ?? 1, event.first ?? 0, event.rows ?? 20);
  }

  onCompletedTimesheetPageLoad(event: any) {
    this.loadProcessedData(event.startingPageNumber ?? 1, event.first ?? 0, event.rows ?? 20);
  }

  loadProcessedData(startingPageNumber = 1, currentPage = 0, recordsPerPage = 20) {
    const processedPayload = this.buildRequestPayload(
      'consumerTimesheetCompletedList',
      startingPageNumber,
      recordsPerPage,
      this.processedSearchParams
    );

    if (!this.processedSearchParams.length && this.timesheetSearchForm?.get('status')?.value) {
      processedPayload.searchParam.push({
        jsonPath: 'businessStatusLkp',
        value: this.timesheetSearchForm?.get('status')?.value,
        operator: 'Equal',
      });
    }

    this.listService
      .getListData(processedPayload, 'claims')
      .subscribe((data: any) => {
        const processedData = this.processTimesheetData(data.responsedata);

        // Sort the merged set, not just this page, so ordering holds across
        // page boundaries.
        this.processedConsumerTimesheets = this.filterRecords(
          startingPageNumber > 1
            ? [...this.processedConsumerTimesheets, ...processedData]
            : processedData
        );

        if (this.completedTimesheetChildComponent) {
          this.completedTimesheetChildComponent.recordsPerPage = recordsPerPage;
          this.completedTimesheetChildComponent.resetPagination(startingPageNumber, currentPage);
        }
      });
  }

  loadInProgressData(startingPageNumber = 1, currentPage = 0, recordsPerPage = 20) {
    const inProcessPayload = this.buildRequestPayload(
      'consumerTimesheetProcessList',
      startingPageNumber,
      recordsPerPage,
      this.inProcessSearchParams
    );
    this.listService
      .getListData(inProcessPayload, 'claims')
      .subscribe((data: any) => {
        const records = this.processInProcessConsumerTimesheets(data.responsedata);

        // Re-sort the merged set so ordering holds across page boundaries.
        if (startingPageNumber > 1) {
          this.inProcessConsumerTimesheets = this.sortByServiceDateAndTimeIn([
            ...this.inProcessConsumerTimesheets,
            ...records,
          ]);
        } else {
          this.clearInProcessSelection();
          this.inProcessConsumerTimesheets = records;
        }

        if (this.inProcessTimesheetChildComponent) {
          this.inProcessTimesheetChildComponent.recordsPerPage = recordsPerPage;
          this.inProcessTimesheetChildComponent.resetPagination(startingPageNumber, currentPage);
        }
      });
  }

  sortByServiceDateAndTimeIn(records: any[]) {
    return records.sort((a: any, b: any) => {
      const dateA = new Date(a.serviceDate + ' ' + a.timeIn) as any;
      const dateB = new Date(b.serviceDate + ' ' + b.timeIn) as any;

      // Sorts by serviceDate and timeIn in ascending order
      return dateA - dateB;
    });
  }

  processInProcessConsumerTimesheets(responseData: any) {
    this.sortByServiceDateAndTimeIn(responseData);

    responseData.map((entry: any) => {
      entry.actions = {};
      const businessStatus = this.businessStatusList.find((gen: LookupValueItem) => {
        return gen.lkpValueCode === entry.business_status_lkp;
      });

      if (businessStatus) {
        entry.businessStatus = businessStatus.lkpValueName;
        if (businessStatus.lkpValueCode === "AC" && !this.isReadOnly && this.canApproveReject) {
          entry.actions.approve = true;
          entry.actions.deny = true;
        }
      }

      // OTE entries are copied from the parent timesheet, so their time in/out
      // carry no real meaning. Show them as '-' in the grid.
      if (CommonUtil.isOvertimeRow(entry)) {
        entry.timeIn = '-';
        entry.timeOut = '-';
      }
    });

    return responseData;
  }

  filterRecords(data: any) {
    data.sort((a: any, b: any) => {
      const dateA = new Date(a.payrollStartDate);
      const dateB = new Date(b.payrollStartDate);
      return dateA.getTime() - dateB.getTime(); // Sorts in ascending order
    });

    return data;
  }

  updated(event: any) {
    if (event) {
      if (this.viewDialogId) {
        this.dialogSvc.closeDialog(this.viewDialogId);
        this.loadInitData();
        this.viewDialogId = null;
      }
    }
  }

  buildRequestPayload(pageName: string, startingPageNumber: number, recordsPerPage = 20, searchParams: any[] = []) {
    const payload: any = {
      pageName: pageName,
      programCode: this.programName,
      condition: 'and',
      recordsPerPage,
      startingPageNumber: startingPageNumber,
      searchParam: searchParams.length > 0 ? searchParams : [
        {
          jsonPath: 'participantId',
          value: this.consumerId,
          operator: 'Equal',
        },
      ],
      orderByColumn: ['tasMasterPayrollScheduleId'],
      orderBy: ['desc'],
    };

    return payload;
  }

  getProviders() {
    this.providerService
      .getProviderList(this.programName, this.consumerId)
      .subscribe((data: any) => {
        this.providers = data.responsedata;
      });
  }

  getPayPeriod() {
    this.timesheetService
      .getPayPeriod(this.programName)
      .subscribe((data: any) => {
        this.payPeriod = data.responsedata;
      });
  }

  private setPageAccess() {
    const authConfig = this.allowListStore.getConfig();
    if (authConfig && !authConfig.pages[this.pageId]) {
      this.isReadOnly = true;
    }
    this.canApproveReject = this.allowListStore.isButtonAllowed(this.pageId, 'approveReject');
    this.isPageRestrictionLoaded = true;
  }

  onView(eventData: any, from: string) {
    this.providerPplId = eventData?.providerPplId;
    let filters: { jsonPath: string; value?: any; values?: any[]; operator: string }[];
    if (from === 'Processed') {
      filters = [
        {
          jsonPath: "servicePeriodId",
          value: eventData.tasMasterPayrollScheduleId,
          operator: "Equal"
        },
        {
          jsonPath: "participantId",
          value: eventData.participantId,
          operator: "Equal"
        },
        {
          jsonPath: "providerId",
          value: eventData.providerId,
          operator: "Equal"
        }
      ];

      // Narrow by status only when the user filtered by it; SPLT is included so split entries can still be grouped.
      const appliedStatus = this.getAppliedProcessedStatus();
      if (appliedStatus) {
        filters.push({
          jsonPath: "businessStatusLkp",
          values: [appliedStatus, 'SPLT'],
          operator: "in"
        });
      }
    } else {
      filters = [
        {
          jsonPath: "timesheetLineId",
          value: eventData.timesheetLineId,
          operator: "Equal"
        }
      ];
    }

    const processedPayload = this.buildTimesheetRequestPayload(
      'staffEditTimesheetEntry',
      filters
    );

    this.listService
      .getListData(processedPayload, 'claims')
      .subscribe((data: any) => {
        this.consumerLineData = this.processData(data.responsedata, eventData);
        this.openViewPopup();
      });
  }

  // Status the Processed grid is filtered by, resolved the same way loadProcessedData applies it.
  private getAppliedProcessedStatus() {
    const statusParam = this.processedSearchParams.find((param: any) => param.jsonPath === 'businessStatusLkp');
    if (statusParam) {
      return statusParam.value;
    }
    return this.processedSearchParams.length ? null : this.timesheetSearchForm?.get('status')?.value;
  }

  buildTimesheetRequestPayload(pageName: string, searchParams: any) {
    const payload: any = {
      pageName: pageName,
      programCode: this.programName,
      condition: 'and',
      recordsPerPage: 20,
      startingPageNumber: '1',
      searchParam: searchParams,
      orderByColumn: [],
      orderBy: ['desc'],
    };

    return payload;
  }

  processData(data: any[], eventData: any) {
    data.forEach(e => {
      if (eventData?.providerName) {
        e.providerName = eventData.providerName;
      }

      const businessStatus = this.businessStatusList.find((gen: LookupValueItem) => {
        return gen.lkpValueCode === e.businessStatusLkp;
      });

      if (businessStatus) {
        e.businessStatus = businessStatus.lkpValueName;
      }

      const processingStatus = this.processingStatusList.find((gen: LookupValueItem) => {
        return gen.lkpValueCode === e.processingStatusLkp;
      });

      if (processingStatus) {
        e.processingStatus = processingStatus.lkpValueName;
      }

      const reason = this.reasonList.find((gen: LookupValueItem) => {
        return gen.lkpValueCode === e.reasonLkp;
      });

      if (reason) {
        e.reason = reason.lkpValueName;
      }

      if (STATIC_DATA.STATUS_FOR_AUTH.includes(e.businessStatusLkp) || STATIC_DATA.PROCESSING_STATUS_FOR_AUTH.includes(e.processingStatusLkp)) {
        e.authNum = 'View';
      }
      e.tasTimesheetlineDetailId = e.timesheetLineId
    });

    data.sort((a, b) => {
      const dateA = new Date(a.serviceDate);
      const dateB = new Date(b.serviceDate);
      return dateA.getTime() - dateB.getTime(); // Sorts in ascending order
    });

    return data;
  }

  convertTo12HourFormat(time: string): string {
    const [hours, minutes] = time.split(":").map(Number);
    const period = hours >= 12 ? 'PM' : 'AM';
    const adjustedHour = hours % 12 || 12;
    const formattedTime = `${adjustedHour}:${minutes < 10 ? '0' + minutes : minutes} ${period}`;
    return formattedTime;
  }

  inProcessTimesheetSearch() {
    const formData = this.inProcessTimesheetSearchForm.value;
    const searchParam: { jsonPath: string; value: any; operator: string }[] = [
      {
        jsonPath: 'participantId',
        value: this.consumerId,
        operator: 'Equal',
      },
    ];

    if (formData.paPplId && formData.paPplId.trim()) {
      searchParam.push({
        jsonPath: 'providerPplId',
        value: formData.paPplId.trim(),
        operator: 'Equal',
      });
    }

    if (formData.paName) {
      searchParam.push({
        jsonPath: 'providerId',
        value: formData.paName,
        operator: 'Equal',
      });
    }

    if (formData.status) {
      searchParam.push({
        jsonPath: 'business_status_lkp',
        value: formData.status,
        operator: 'Equal',
      });
    }

    // Persist the filters so paging past page 1 refetches the same filtered set.
    this.inProcessSearchParams = searchParam;
    this.loadInProgressData(1, 0, this.inProcessTimesheetChildComponent?.recordsPerPage ?? 20);
  }

  search() {
    const formData = this.timesheetSearchForm.value;
    const searchParam: { jsonPath: string; value: any; operator: string }[] = [
      {
        jsonPath: 'participantId',
        value: this.consumerId,
        operator: 'Equal',
      },
    ];

    if (formData.provider) {
      searchParam.push({
        jsonPath: 'providerId',
        value: formData.provider,
        operator: 'Equal',
      });
    }

    if (formData.status) {
      searchParam.push({
        jsonPath: 'businessStatusLkp',
        value: formData.status,
        operator: 'Equal',
      });
    }

    if (formData.payPeriod) {
      searchParam.push({
        jsonPath: 'tasMasterPayrollScheduleId',
        value: formData.payPeriod.payrollId,
        operator: 'Equal',
      });
    }

    // Persist the filters so paging past page 1 refetches the same filtered set.
    this.processedSearchParams = searchParam;
    this.loadProcessedData(1, 0, this.completedTimesheetChildComponent?.recordsPerPage ?? 20);
  }

  processTimesheetData(processedTimesheets: any) {
    return processedTimesheets.map((entry: any) => {
      const businessStatus = this.businessStatusList.find((gen: LookupValueItem) => {
        return gen.lkpValueCode === entry.businessStatusLkp;
      });

      if (businessStatus) {
        entry.businessStatus = businessStatus.lkpValueName;
      }

      return entry;
    });
  }

  createUpdatePayload(status: string) {
    return {
      timesheetIds: [this.rowData?.timesheetLineId],
      status: status,
      programCode: this.programName,
      participantId: this.rowData?.participantId || null,
      providerId: this.rowData?.providerId || null,
      remarks: this.selectedReason,
    };
  }

  onInProcessSelectionChanged(event: any) {
    this.selectedInProcessRows = Array.isArray(event) ? event : [];
  }

  approveSelected() {
    if (!this.hasValidSelection('approved')) {
      return;
    }
    this.isBulkDeny = false;
    this.updateBulkStatus('GP');
  }

  rejectSelected() {
    if (!this.hasValidSelection('denied')) {
      return;
    }
    this.isBulkDeny = true;
    this.openDenyPopup();
  }

  /**
   * Selection is already restricted to 'AC' lines by inProcessSelectionDisabler; this
   * guards against an empty selection and against stale rows left over from a reload.
   */
  private hasValidSelection(action: string): boolean {
    if (!this.selectedInProcessRows.length) {
      this.errorAlertService.openModal(
        'error',
        'Error',
        'Please select lines for completing this action.'
      );
      return false;
    }

    if (this.selectedInProcessRows.some((entry: any) => entry?.business_status_lkp !== 'AC')) {
      this.errorAlertService.openModal(
        'error',
        'Error',
        `Payrolls can only be ${action} if they are currently waiting for participant approval.`
      );
      return false;
    }

    return true;
  }

  createBulkUpdatePayload(status: string) {
    return {
      timesheetIds: this.selectedInProcessRows.map((row: any) => row?.timesheetLineId),
      status: status,
      programCode: this.programName,
      participantId: this.selectedInProcessRows[0]?.participantId ?? this.consumerId,
      remarks: this.selectedReason,
    };
  }

  updateBulkStatus(status: string) {
    const payload = this.createBulkUpdatePayload(status);
    this.selectedReason = '';
    this.timesheetService
      .updateStatusConsumerTimesheet(payload, status)
      .subscribe(() => {
        this.clearInProcessSelection();
        this.loadInitData();
      });
  }

  private clearInProcessSelection() {
    this.selectedInProcessRows = [];
    if (this.inProcessTimesheetChildComponent) {
      this.inProcessTimesheetChildComponent.selectedCheckBoxValue = [];
    }
  }

  onAction(event: any, isProcessed: boolean, from: string) {
    this.isProcessed = isProcessed;
    this.rowData = event.data;
    if (event.action === 'view') {
      if (event?.data?.business_status_lkp === "AC") {
        this.isProcessed = false;
      }

      this.onView(event.data, from);
    }
    if (event.action === 'deny') {
      this.isBulkDeny = false;
      this.openDenyPopup();
    }
    if (event.action === 'approve') {
      this.isBulkDeny = false;
      this.updateStatus('GP');
    }
  }

  updateStatus(status: string) {
    const payload = this.createUpdatePayload(status);
    this.timesheetService
      .updateStatusConsumerTimesheet(payload, status)
      .subscribe((data: any) => {
        console.log('after update status timesheet', data);
        this.loadInitData();
      });
  }

  openViewPopup() {
    const dialogConfig: DialogConfig = {
      title: 'Timesheet',
      okText: 'Save',
      size: 'xx-large',
      position: 'top',
      showClose: true,
      showButtons: false,
    };

    this.viewDialogId = this.dialogSvc.openDialog(
      this.timesheetViewDialog,
      dialogConfig,
      () => this.handleCancel(),
      () => this.handleCancel()
    );
  }

  openDenyPopup() {
    const dialogConfig: DialogConfig = {
      title: 'Deny Payroll',
      okText: 'Deny',
      size: 'medium',
      position: 'top',
      showClose: true,
      showButtons: true,
    };

    this.dialogSvc.openDialog(
      this.denyDialog,
      dialogConfig,
      () => this.handleOk(),
      () => this.handleCancel()
    );
  }

  handleCancel() {
    this.selectedReason = '';
    this.isBulkDeny = false;
  }

  handleOk() {
    if (this.isBulkDeny) {
      this.updateBulkStatus('CD');
    } else {
      this.updateStatus('CD');
    }
    this.isBulkDeny = false;
  }
}
